import { isSameDay } from '@myre/common-dates';
import { TagType } from '@myre/common-tag';
import { TranslatePipe } from '@myre/ui-primitive-core';

import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { type CalendarEvent } from '../myre-calendar/myre-calendar.interface';
import { MyreEventCalendarEventComponent } from '../myre-event-calendar-event/myre-event-calendar-event.component';
import { MyreEventCalendarPopupComponent } from '../myre-event-calendar-popup/myre-event-calendar-popup.component';
import { type EventCalendarDay } from '../myre-month-view/myre-month-view.interface';

@Component({
  selector: '[myre-event-calendar-body]',
  templateUrl: './myre-event-calendar-body.component.html',
  styleUrls: ['./myre-event-calendar-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    MyreEventCalendarEventComponent,
    MyreEventCalendarPopupComponent,
    TranslatePipe,
  ],
})
export class MyreEventCalendarBodyComponent {
  @Input()
  public rows: EventCalendarDay[][];

  @Input()
  public canEdit: boolean = false;

  /** The value in the table that corresponds to today. */
  @Input()
  public todayValue: number;

  @Output()
  public onEventCreated = new EventEmitter<Date>();

  @Output()
  public onEventUpdated = new EventEmitter<CalendarEvent>();

  public TagTypeEnum: typeof TagType = TagType;

  public isOpen: boolean = true;

  public trackByFnc(_: number, event: CalendarEvent): number {
    return event.id;
  }

  public onEventCreatedClick(date: Date): void {
    if (this.canEdit) {
      this.onEventCreated.emit(date);
    }
  }

  public onEventUpdatedEmit(event: CalendarEvent): void {
    this.isOpen = false;
    this.onEventUpdated.emit(event);
  }

  public onClosePopupsEmit(isOpen: boolean): void {
    this.isOpen = isOpen;
  }

  /** Returns whether timestamp is today. */
  public isTodayCell(timestamp: number): boolean {
    return isSameDay(this.todayValue, timestamp);
  }
}
